import React, { useEffect } from 'react';
import { removeAuthData, removeUserPreferences } from '../common/localeStorageUtils';

import { useTranslation } from 'react-i18next';

export default function SignOut() {
  const { i18n } = useTranslation();
  useEffect(() => {
    debugger;
    removeAuthData();
    removeUserPreferences();
    window.location.replace(
      `${process.env.REACT_APP_AZURE_B2C_SIGN_OUT_URL}`!.replace(
        `sign-in`,
        `sign-in?lang=${i18n.language}`
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div></div>;
}
